import { ChevronLeftIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { ROUTES } from '@crm/shared/routes';

import { getBackNavigationLabelKey } from '../model/backNavigation';

import type { BackNavigationState } from '@crm/shared/routes';

export const BackNavigation = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const navigationState = location.state as BackNavigationState | null;
    const fromRoute = navigationState?.fromRoute;

    const handleBack = () => {
        if (fromRoute) {
            navigate(-1);
            return;
        }

        navigate(ROUTES.DEALS);
    };

    return (
        <button
            type="button"
            className="flex items-center gap-1 text-xs text-smtr-main-tertiary-100 transition-colors hover:text-smtr-main-black-100"
            onClick={handleBack}
        >
            <ChevronLeftIcon size={16} />
            {t(getBackNavigationLabelKey(fromRoute))}
        </button>
    );
};
